export default __webpack_public_path__ + "tip.393bfbfd.svg";